module.exports = __webpack_public_path__ + "img/num.3b90789c.svg";